import script from "./ComOikeudet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComOikeudet.vue?vue&type=script&setup=true&lang=ts"

import "./ComOikeudet.vue?vue&type=style&index=0&id=a85c7ef8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a85c7ef8"]])

export default __exports__